// extracted by mini-css-extract-plugin
export default {"icon":"Itembox_icon__igIlM","menu-popper":"Itembox_menu-popper__LJH+M","menu-item":"Itembox_menu-item__JFMlg"};